/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-25 09:49:57
 */
import Vue from 'vue';
import piWxQrcode from './pi-wx-qrcode.vue';

const SuccessBoxConstructor = Vue.extend(piWxQrcode);

let getAnInstance = () => {
  return new SuccessBoxConstructor({
    el: document.createElement('div')
  });
};

let piWxQrcodeBox = (data = {}) => {
  let instance = getAnInstance();
  instance.getOperInfo(data);
  // instance.confirmFn = () => {
  //   colse();
  //   options.confirm && options.confirm();
  // };
  // instance.cancelFn = () => {
  //   options.cancel && options.cancel();
  //   colse();
  // };

  // let colse = async () => {
  //   instance.divShow = false;
  //   setTimeout(() => {
  //     instance.$el.parentNode.removeChild(instance.$el);
  //   }, 400);
  // };

  document.body.appendChild(instance.$el);
};

export default piWxQrcodeBox;
